import { useState } from 'react';
import { useUser } from '../context/UserContext';
import { DatabaseUserModel } from '../services/DatabaseUser';
import { AddToCartIcon, RemoveFromCartIcon } from '../constants/icons';

interface CartToggleButtonProps {
    packId: string;
}

// The add/remove control that floats on a Browse Packs cover: a 34px white
// rounded square with a soft shadow. The cart rail only ever shows packs that
// aren't in the cart, so in practice this adds — and scale-pops once when it
// does. Toggle semantics are kept for any other caller.
function CartToggleButton({ packId }: CartToggleButtonProps) {
    const { user, userData } = useUser();
    const [popping, setPopping] = useState(false);

    const inCart = userData?.cartItems?.includes(packId) ?? false;

    const handleToggle = async () => {
        if (!user) return;
        if (inCart) {
            await DatabaseUserModel.removeFromCart(user.uid, packId);
        } else {
            setPopping(true);
            setTimeout(() => setPopping(false), 400);
            await DatabaseUserModel.addToCart(user.uid, packId);
        }
    };

    return (
        <button
            onClick={handleToggle}
            className={`flex h-[34px] w-[34px] flex-shrink-0 items-center justify-center rounded-lg bg-white text-ink-secondary shadow-[0_1px_4px_rgba(0,0,0,0.18)] transition-colors hover:bg-[#f0f0f0] ${
                popping ? 'animate-cartpop' : ''
            }`}
            title={inCart ? 'Remove from cart' : 'Add to cart'}
        >
            {inCart ? <RemoveFromCartIcon /> : <AddToCartIcon />}
        </button>
    );
}

export default CartToggleButton;
